// GAVION X2: objection library (dialer panel + Paramètres → Objections)
export const objectionsFr = {
  title: "Objections",
  panel: {
    title: "Objections",
    search: "Rechercher une objection",
    search_hint: "O pour chercher",
    empty: "Aucune objection pour ce métier.",
    no_match: "Aucune objection ne correspond.",
    generic: "Tous les métiers",
    worked: "Ça a marché",
    worked_done: "Merci, noté!",
    worked_error: "Impossible d'enregistrer. Réessayez.",
    load_error: "Impossible de charger les objections.",
  },
  settings: {
    intro:
      "Les réponses suggérées aux représentants dans l'écran d'appel, filtrées selon le métier de la compagnie.",
    read_only:
      "Lecture seule: seuls les administrateurs modifient les objections.",
    new: "Nouvelle objection",
    filter_trade: "Métier",
    all: "Tous",
    generic: "Tous les métiers (générales)",
    show_inactive: "Afficher les inactives",
    none: "Aucune objection.",
    edit: "Modifier",
    deactivate: "Désactiver",
    reactivate: "Réactiver",
    edit_label: "Modifier: %{name}",
    deactivate_label: "Désactiver: %{name}",
    reactivate_label: "Réactiver: %{name}",
    deactivated: "Objection désactivée.",
    reactivated: "Objection réactivée.",
    saved: "Objection enregistrée.",
    save_error: "Impossible d'enregistrer. Réessayez.",
    columns: {
      objection: "Objection",
      trade: "Métier",
      tags: "Étiquettes",
      helpful: "Ça a marché",
      order: "Ordre",
      status: "Statut",
      actions: "Actions",
    },
    status: { active: "Active", inactive: "Inactive" },
    dialog: {
      create_title: "Nouvelle objection",
      edit_title: "Modifier l'objection",
      trade: "Métier",
      objection: "Objection (ce que dit le client)",
      response: "Réponse suggérée",
      tags: "Étiquettes (séparées par des virgules)",
      sort_order: "Ordre d'affichage",
      active: "Active",
      save: "Enregistrer",
      cancel: "Annuler",
    },
    errors: {
      required: "Ce champ est obligatoire.",
      too_long: "Texte trop long.",
      invalid: "Entrez un nombre entier.",
      too_many: "8 étiquettes au maximum.",
    },
  },
};
